<template>
  <el-dialog
    :title="title"
    :visible.sync="templeShowDialog"
    width="80%"
    center
    :append-to-body="true"
    @open="handleOpen"
    @close="closeDialog"
  >
    <el-row :gutter="12">
      <el-col :span="8">
        <el-card shadow="never">
          <div slot="header" style="text-align: center">
            <span>选择区域</span>
          </div>
          <el-tree
            ref="tree"
            :data="treeData"
            node-key="id"
            show-checkbox
            highlight-current
            :props="treeProp"
            :default-checked-keys="defaultKey"
            @check="currentCheck"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ data }">
              <span>{{ data.name }}</span>
            </span>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="16"
        ><el-card shadow="never">
          <div slot="header" style="text-align: center">
            <span>设置水价</span>
          </div>
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :rules="formRules"
            :isQueryPanel="false"
          ></SiruiSearch> </el-card
      ></el-col>
    </el-row>
    <div class="bottom">
      <el-button type="primary" @click="closeDialog" class="btn-cancer">取消</el-button>
      <el-button type="primary" @click="save" :loading="load" class="btn-save">保存</el-button>
      <el-button type="primary" @click="sumbit" :loading="load" class="btn-save"
        >提交审核</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
  import API from '@/api/property/meterManagement';
  import { column } from './addAreaDialog.js';

  export default {
    name: 'AddAreaDialog',
    computed: {
      formColumn() {
        return column(this);
      },
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'add',
      },
      priceId: {
        type: String,
        default: '',
      },
      form: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        treeProp: {
          disabled: (data) => {
            if (data.leafFlag == 1 && data.children == null) {
              return true;
            }
          },
        },
        templeShowDialog: this.showDialog,
        defaultKey: [],
        baseFormData: {
          startDate: '', //起始月份
          endDate: '', //截至月份
          price: '', //水价
          remark: '', //备注
          createPersonName: '', //创建人
          gmtCreate: '', //创建时间
          spaceList: '', //片区
          category: '',
          submitApproval: false,
        },
        treeData: [],
        ids: [],
        formRules: {
          startDate: [{ required: true, message: '请选择开始月份', trigger: 'blur' }],
          category: [{ required: true, message: '请选择水表类别', trigger: 'blur' }],
          endDate: [
            { required: true, message: '请选择结束月份', trigger: 'blur' },
            { validator: this.checkEndTime, trigger: 'change' },
          ],
          price: [
            { required: true, message: '请输入单价', trigger: 'change' },
            { pattern: /^[0-9.]*$/, message: '请输入大于等于0的数字', trigger: 'blur' },
          ],
          servicePrice: [
            { pattern: /^[0-9.]*$/, message: '请输入大于等于0的数字', trigger: 'blur' },
          ],
        },
        load: false,
        title: '新增片区水价',
      };
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
    },

    methods: {
      //校验结束时间
      checkEndTime(rule, value, callback) {
        if (this.baseFormData.endDate == '') {
          callback();
        } else if (!this.baseFormData.startDate) {
          callback(new Error('请选择开始月份！'));
        } else if (Date.parse(this.baseFormData.startDate) > Date.parse(value)) {
          callback(new Error('结束月份必须大于开始月份！'));
        } else {
          callback();
        }
      },
      handleOpen() {
        this.getArea();
        this.baseFormData.createPersonName = this.userInfo.userName;
        this.baseFormData.gmtCreate = Date();
        if (this.type == 'edit') {
          this.title = '编辑片区水价';
          this.getDetail();
        } else {
          this.title = '新增片区水价';
        }
      },
      closeDialog() {
        this.$emit('closeDialog', false);
        this.$refs.baseInfoFormRef.resetForm('queryFrom');
        this.defaultKey = [];
        this.load = false;
      },
      // 保存
      save() {
        this.baseFormData.submitApproval = false;
        this.dataHandle();
      },
      // 提交审核
      sumbit() {
        this.baseFormData.submitApproval = true;
        this.dataHandle();
      },
      dataHandle() {
        this.$refs.baseInfoFormRef.validate((valid) => {
          if (valid) {
            console.log(this.$refs.tree.getCheckedNodes());
            let spaceList = this.$refs.tree.getCheckedNodes().filter((i) => {
              return i.leafFlag == 0;
            });
            if (spaceList.length <= 0) {
              return this.$message.warning('请选择片区！');
            }
            let idList = spaceList.map((item) => {
              return {
                spaceAreaId: item.spaceAreaNo,
                spaceAreaName: item.spaceAreaName,
                // spaceAssetId: item.spaceAssetNo,
                // spaceAssetName: item.spaceAssetName,
                // spaceFloorId: item.spaceFloorNo,
                // spaceFloorName: item.spaceFloorName,
                spaceId: item.id,
                spaceName: item.name,
                // spaceUnitId: item.spaceUnitNo,
                // spaceUnitName: item.spaceUnitName,
              };
            });
            this.baseFormData.spaces = idList;
            this.$emit('submit', this.baseFormData);
          }
        });
      },

      // 获取片区数据
      async getArea() {
        const { data } = await this.$axios.post(API.AREA_TREE, {
          spaceCompanyNo: this.userInfo.companyCode,
          auditStatus: '03',
          isEnabled: 1,
        });
        if (data.code == 0) {
          this.treeData = data.data;
        }
      },
      // 水表详情
      async getDetail() {
        const { data } = await this.$axios.get(`${API.WATER_METER_PRICE_DETAIL}/${this.priceId}`);
        if (data.code == 0) {
          this.baseFormData = data.data;
          data.data.spaces.map((item) => {
            let id = '';
            if (item.spaceId ?? '' != '') {
              id = item.spaceId;
            } else if (item.spaceFloorId ?? '' != '') {
              id = item.spaceFloorId;
            } else if (item.spaceUnitId ?? '' != '') {
              id = item.spaceUnitId;
            } else if (item.spaceAssetId ?? '' != '') {
              id = item.spaceAssetId;
            } else {
              id = item.spaceAreaId;
            }
            this.defaultKey.push(id + '');
          });
        }
      },
      currentCheck(data, checkData) {
        this.ids = checkData.checkedNodes;
      },
    },
  };
</script>
<style scoped lang="scss">
  .title {
    font-size: 14px;
    color: black;
    margin-left: 10px;
  }
  .fixed-bottom-btn {
    padding: 0px 0px;
    background-color: #e0e5ff;
    color: #597aff;
    min-width: 60px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }
  .info {
    margin-top: 15px;
    margin-left: 20px;
    color: red;
  }
  .el-card ::v-deep .el-card__header {
    padding: 10px 20px;
  }
  .el-card {
    max-height: 282px;
    overflow: auto;
  }

  .bottom {
    margin-top: 20px;
    margin-bottom: 15px;
    text-align: center;
    .btn-cancer {
      padding: 0px 0px;
      background-color: #e0e5ff;
      color: #597aff;
      min-width: 80px;
      height: 30px;
      margin-right: 20px;
      border: 0px solid #dcdfe6;
    }
    .btn-save {
      padding: 0px 0px;
      background-color: #66b1ff;
      color: white;
      min-width: 80px;
      height: 30px;
      margin-left: 20px;
      border: 0px solid #dcdfe6;
    }
  }
</style>
